import iviewLocale from 'iview/src/locale/lang/mn-MN';

export default {
    "locale": "mn-MN",
    "user": {
        "defaultMenu": "Анхдагч цэс",
        "pleaseWait": "Түр хүлээнэ үү!",
        "role": "Үүрэг",
        "title": "Ламбда платформ",
        "subtitle": "Ламбда платформ",
        "login": "Нэвтрэх",
        "forgot": "Нууц үгээ мартсан?",
        "remember": "Энэ компьютерт сануулах",
        "loginTitle": "СИСТЕМД НЭВТРЭХ",
        "username": "Нэвтрэх нэр",
        "email": "И-мэйл",
        "password": "Нууц үг",
        "loginSuccess": "Амжилттай нэвтэрлээ. Түр хүлээнэ үү!",
        "loginError": "Нэвтрэх нэр эсвэл нууц үг буруу байна!!!",
        "emailRequired": "И-мэйл хаяг аа оруулна уу",
        "emailSendError": "И-мэйл илгээх үед алдаа гарлаа",
        "forgotDescription": "И-мэйл хаягаа оруулаад нууц үг ээ сэргээнэ үү",
        "sendPasswordResetCode": "Нууц үг солих код и-мэйлээр авах",
        "passwordConfirm": "Нууц үг баталгаажуулах",
        "userNotFound": "Хэрэглэгч олдсонгүй !!!",
        "codeSentError": "Нууц үг шинэчлэх код илгээх үед алдаа гарлаа!",
        "passwordReset": "НУУЦ ҮГ ШИНЭЧЛЭХ",
        "passwordResetCode": "Нууц үгээ сэргээх код",
        "passwordResetCodeSent": "Нууц үг шинэчлэх код амжилттай илгээгдлээ !",
        "passwordResetCodeRequired": "Нууц үг солих код  оруулаагүй байна !!!",
        "passwordResetSuccess": "Нууц үг амжилттай шинэчлэгдлээ !",
        "passwordConfirmError": "Нууц үг баталгаажуулалт таарсангүй !!!",
        "passwordResetCodeIncorrect": "Нууц үг сэргээх код буруу байна !!!",
        "passwordResetCodeTimeout": "Нууц үг сэргээх кодын хугацаа дууссан !!!",
        "noReply": "Энэхүү и-мэйл нь автоматаар илгээгдсэн учир хариу бичих шаардлагагүй.",
        "databaseview": "Мэдээллийн сан, харах",
        "dataBase": "өгөгдлийн сан",
        "view": "харах",
        "add": "Нэмэх",
        "characteristics": "Шинж чанар",
        "basic": "Үндэс",
        "column": "Багана",
        "name": "Нэр",
        "optional": "Нэмэлт",
        "filter": "Шүүлтүүр",
        "data": "Өгөгдөл",
        "save": "Хадгалах",
        "tableList": "Хүснэгтийн жагсаалт",
        "aggregation": "Нэгтгэх",
        "sort": "Эрэмбэлэх",
        "use": "Ашиглах",
        "grouping": "Бүлэглэх",
        "type": "Төрөл",
        "alias": "Зохиомол нэр",
        "dataProcessing": "Өгөгдөл боловсруулах",
        "select": "Сонгоно уу",
        "pleaseEnterSearchValue": "Хайх утгаа оруулна уу...",
        "user": "хэрэглэгч",
        "users": "Хэрэглэгчид",
        "totalEmployees": "Нийт ажилчид",
        "deleted": "Устгасан",
        "searchForInformation": "Мэдээллээс хайх",
        "addUser": "Хэрэглэгч нэмэх",
        "noData": "Мэдээлэл олдсонгүй",
        "page": "Хуудсанд",
        "shows": "-г харуулана",
        "categorySearch": "Зэрэглэлээр шүүх",
        "image": "Зураг",
        "lastName": "Овог",
        "firstName": "Нэр",
        "registrationNumber": "Регистрийн дугаар",
        "dateOfBirth": "Төрсөн огноо",
        "gender": "Хүйс",
        "men": "Эрэгтэй",
        "women": "Эмэгтэй",
        "phone": "Утас",
        "resetFrom": "Шинээр бөглөх",
        "permission": "Хандах эрх",
        "loginName": "Нэвтрэх нэр",
        "confirmPassword": "Нууц үг баталгаажуулах",
        "personalInformation": "Хувийн мэдээлэл",
        "changePassword": "Нууц үг солих",
        "settings": "Тохиргоо",
        "logOut": "Системээс гарах",
        "pleaseSelectRole": "Үүрэг сонгоно уу",
        "administraationRightsManagment": "Хандах эрх удирдах",
        "additional": "Нэмэлт",
        "dataSource": "Мэдээллийн эх сурвалж",
        "chart": "График",
        "userList": "Хэрэглэгчдийн жагсаалт",
        "import": "Оруулах",
        "register": "Бүртгэх",
        "confirm": "Баталгаажуулах",
        "menuSelection": "Цэс сонгох",
        "noMatchingData": "Тохирох өгөгдөл байхгүй байна",
        "nickName": "Харагдах нэр",
        "note": "Тайлбар",
        "pleaseEnterVisibleName": "Харагдах нэрийг оруулна уу",
        "firstNameandLastName": "Овог нэр",
        "mobile": "Гар утас",
        "createdDate": "Үүсгэсэн огноо",
        "registrationConfirmed": "БҮРТГЭЛ БАТАЛГААЖСАН",
        "registrationIsNotConfirmed": "БҮРТГЭЛ БАТАЛГААЖААГҮЙ",
        "success": "Амжилттай",
        "systemUpdate": "Систем шинэчлэх",
        "sendDataStructure": "Өгөгдлийн бүтцийг илгээх",
        "pleaseReEnterYourPassword": "Нууц үгээ дахин оруулна уу?",
        "theValueIsRegistered": "утга бүртгэлтэй байна",
        "possibleTableView": "Боломжиж table болон view",
        "table": "Хүснэгт",
        "ascending": "өсөхөөр",
        "descending": "Буурах",
        "byLoginName": "Нэвтрэх нэрээр",
        "dateAdded": "Нэмсэн огноо",
        "inPage": "Хуудсанд",
        "show": "харуулана",
        "outOf": "Нийт",
        "fromUsers": "хэрэглэгчдээс",
        "showing": "харуулж байна",
        "noInfo": "Мэдээлэл алга",
        "ruconfinfo": "Ажилтны мэдээллийг сэргээхдээ итгэлтэй байна уу?",
        "ruconfinfoDelete": "Ажилтны мэдээллийг бүр мөсөн устгахдаа итгэлтэй байна уу?",
        "created": "Үүсгэсэн",
        "userDeleted": "Хэрэглэгч устгагдлаа",
        "_logout": "Гарах",
        "_cancel": "Болих",
        "listOfDeletedUsers": "Устгасан хэрэглэгчдийн жагсаалт",
        "by": " - аар",
        "no": "Үгүй",
        "yes": "Тийм",
        "completeDestruction": "Бүрэн устгах",
        "recovery": "Сэргээх",
        "errorOccWhileDeleting": "Устгах үед алдаа гарлаа",
        "userInformationRestored": "Хэрэглэгчийн мэдээлэл сэргээгдлээ",
        "errorOccurredWhileRetrievingData": "Мэдээлэл сэргээхэд алдаа гарлаа.",
        "total": "Нийт",
        "edit": "Засах",
        "pleaseLogInUsingYourRegUnamePassword": "Та өөрийн бүртгэлтэй нэвтрэх нэр, нууц үгийг ашиглан нэвтэрнэ үү!",
        "frequentlyAskedQuestions": "Түгээмэл асуулт",
        "toContaqt": "Холбоо барих",
        "downloadYourMobileApp": "Гар утасны аппликейшнээ татаарай.",
        "instructionsUse": "Ашиглах заавар",
        "hayg": "Монгол улс, Улаанбаатар хот, Сүхбаатар дүүрэг 9-р хороо, их тойруу 54, Компьютер Молл, 8 давхар, 8002 тоот",
        "plseResUrPassUsingUrRegisteredEmail": "Та өөрийн бүртгэлтэй И-мэйл хаягаа ашиглан нууц үгээ сэргээнэ үү?",
        "downloadAppHere": "Эндээс Апп татаарай"
    },
    "agent_wizard": {
        "confirm_registration_information": "Бүртгэлийн мэдээлэл баталгаажуулах",
        "step": "Алхам",
        "hello": "Сайн байна уу?",
        "your_name": "Таны нэр",
        "your_last_name": "Таны овог",
        "name_desc": "Таны жинхэнэ нэр нь латин болон монгол үсгийн аль нэгээр, хамгийн ихдээ 75 тэмдэгтэд багтаан бичнэ үү.",
        "last_name_desc": "Таны овог нь латин болон монгол үсгийн аль нэгээр, хамгийн ихдээ 75 тэмдэгтэд багтаан бичнэ үү.",
        "your_birthday": "Таны төрсөн огноо",
        "your_gender": "Таны хүйс",
        "women": "Эмэгтэй",
        "man": "Эрэгтэй",
        "_register": "Регистрийн дугаар",
        "register_desc": "Та регистрийн дугаараа оруулан уу. Зөвхөн монгол үсгээр бичнэ үү.",
        "example": "Жишээ нь",
        "contact_information": "Холбоо барих мэдээлэл",
        "your_email_address": "Таны E-mail хаяг",
        "email_desc": "Та цахим шуудангийн хаягаа бичнэ үү. Латин тэмдэгтээр, жижиг үсгээр, зайгүй бичнэ үү.",
        "your_phone_number": "Таны гар утсаны дугаар",
        "phone_desc": "Та гар утасны дугаараа бичнэ үү. Зөвхөн цифр ашиглаж, дундаа зайгүй бичнэ үү.",
        "profile_image": "Профайл зураг",
        "profile_image_uploud": "Профайл зураг оруулах",
        "profile_desc": "Та профайл зургаа сонгож серверт байрлуулана уу. Зургийн хэмжээ нь 1mb хэтрэхгүй тэгш харьцаатай байх ёстой.",
        "your_new_password": "Таны шинэ нууц үг",
        "password_desc": "Нууц үг нь латин үсгээр, том болон жижиг үсэг, тоо, тусгай тэмдэг орсон, дундаа зайгүй байх ёстой.",
        "rep_your_new_password": "Шинэ нууц үгээ давтан батлах",
        "_prev": "Өмнөх",
        "_next": "Дараах",
        "enter_personal_information": "Та өөрийн хувийн мэдээллээ үнэн зөв оруулна уу!",
        "enter_contact_information": "Та өөрийн холбоо барих мэдээллээ үнэн зөв оруулна уу!",
        "please_change_your_password": "Та нууц үгээ шинээр сольж оруулна уу! Таны шинээр оруулсан нууц үг цаашид ашиглагдах болно",
        "please_contact_system_administor": "Хэрэв танд ямар нэг тусламж хэрэгтэй бол систем админд аа хандана уу",
        "back": "Буцах",
        "entered_information": "Таны оруулсан мэдээлэл",
        "information_alert": "Та өөрийн мэдээллээ хянаж шалгаад, үнэн зөв бол системд илгээнэ үү.",
        "no_information": "мэдээлэл алга",
        "date_you_added_system": "Таныг систэмд нэмсэн огноо",
        "send_registration": "Бүртгэлийг илгээх",
        "userDeleted": "Хэрэглэгч устгагдлаа.",
        "errorOccurredDeleting": "Устгах үед алдаа гарлаа.",
        "UserInformationRestored": "Хэрэглэгчийн мэдээлэл сэргээгдлээ.",
        "ErrorRetrievingData": "Мэдээлэл сэргээхэд алдаа гарлаа!",
        "NoSearchResultsFound": "Хайлтанд илэрц олдсонгүй!",
        "SpacesAreIncluded": "Хоосон зай орсон байна."
    },
    "adminModule": {
        "db": "Өгөгдлийн сан",
        "usersAndUserGroups": "ХЭРЭГЛЭГЧ, ХАНДАХ ЭРХ",
        "users": "Хэрэглэгчид",
        "userGroupsPermission": "Хандах эрх, Зөвшөөрөл",
        "sendDBSchema": "Өгөгдлийн сангийн бүтцийг илгээх",
        "AddColumn": "Багана нэмэх",
        "systemUpdate": "Систем шинэчлэх",
        "graphic": "График",
        "column": "Багана",
        "dataType": "Өгөгдлийн төрөл",
        "form": "Маягт",
        "table": "Хүснэгт",
        "original_preparation": "Эх бэлтгэл",
        "pleaseWait": "Түр хүлээнэ үү!",
        "_form": "Форм",
        "value_column": "Утга багана",
        "Custom_column": "Хэрэглэгчийн багана",
        "list_grid": "Жагсаалт | Grid (шүүлтүүр)",
        "judgment_column": "Шүүлт хийх багана",
        "form_value": "Форм (Авах утга)",
        "InformationSuccessfullyDistributed": "Мэдээлэл амжилттай хувиарлагдлаа!",
        "InformationReturned": "Мэдээлэл буцаагдлаа!"
    },
    "graphql": {
        "graphqlManagement": "Graphql удирдлага",
        "table": "Хүснэгт",
        "selectTable": "Хүснэгт сонгох",
        "name": "Нэр",
        "idField": "ID талбар",
        "hideFields": "Нуух талбарууд",
        "permissionActions": "Зөвшөөрөх үйлдлүүд",
        "add": "Нэмэх",
        "edit": "Засах",
        "delete": "Устгах",
        "save": "Хадгалах",
        "accessAndAccessRights": "Нэвтрэлт болон хандах эрх",
        "nevtersenHundHaruulah": "Нэвтэрсэн хүнд харуулна.",
        "accessRights": "Харах боломжтой хандах эрх",
        "allUsersCanSee": "Эрх тавьж өгөөгүй тохиолдолд бүх хэрэглчид харах боломжтой.",
        "subTables": "Дэд хүснэгтүүд",
        "subTable": "Дэд хүснэгт",
        "connectionField": "Холбох талбар",
        "tableList": "Хүснэгтийн жагсаалт",
        "viewList": "View жагсаалт",
        "real_time": "Бодит цагийн захиалга",
        "cancel": "Болих",
        "tableParentId": "Эцэг хүснэгтийн ID",
        "action": "Үйлдэл"
    },
    "components": {
        "add": "Нэмэх",
        "pleaseEnterSearchValue": "Хайх утгаа оруулна уу...",
        "pleaseWait": "Түр хүлээнэ үү!",
        "deleteData": "Өгөгдөлийг устгах уу?",
        "name": "Нэр",
        "yes": "Тийм",
        "no": "Үгүй",
        "copy": "Хувилах",
        "table": "Хүснэгт",
        "basicTable": "Үндсэн хүснэгт",
        "selectTable": "Хүснэгт сонгох",
        "applications": "Програмууд",
        "additions": "Нэмэлтүүд",
        "logistics": "Ложистик",
        "letter": "Захидал",
        "fileDirectory": "Файлын сан",
        "admin": "Админ",
        "systemAdministrator": "Системийн админ",
        "personalInformation": "Хувийн мэдээлэл",
        "settings": "Тохиргоо",
        "logOut": "Системээс гарах",
        "changePassword": "Нууц үг солих",
        "projectList": "Төслийн жагсаалт",
        "table_list": "Хүснэгтийн жагсаалт",
        "ui_builder": "UI бүтээгч",
        "_form": "Маягт",
        "someContents": "Зарим агуулга",
        "_cancel": "Болих"
    },
    "chart": {
        "horizontal_value": "Хөндлөн утга",
        "groupBy": "бүлэглэх",
        "line": "Шугам",
        "_big": "Том",
        "_small": "Жижиг",
        "field": "Талбар",
        "settings": "Тохиргоо",
        "icon": "Дүрс",
        "bg_color": "Дэвсгэр өнгө",
        "text_color": "Текстийн өнгө",
        "link_title": "Гарчгийн холбоос",
        "link": "Холбоос",
        "values": "Утга",
        "element_type": "Элементийн төрөл",
        "_filter": "Шүүлтүүр",
        "_name": "Нэр",
        "responsible_value": "Хариуцуулах утга",
        "_save": "Хадгалах",
        "enter_name": "Нэр оруулна уу...",
        "data_table": "Өгөгдлийн хүснэгт",
        "selectTable": "Хүснэгт сонгох",
        "aggregation": "Нэгтгэх",
        "no": "Үгүй",
        "count": "Тоо",
        "_max": "Хамгийн их",
        "_min": "Хамгийн багадаа",
        "_avg": "Дундаж",
        "_sum": "Sum",
        "count_distinct": "Тоо",
        "avg_distinct": "Дундаж ялгаа",
        "sum_distinct": "Онцлог нийлбэр",
        "_sort": "Эрэмбэлэх",
        "no_sort": "Эрэмблэхгүй",
        "grouping": "Бүлэглэх",
        "_type": "Төрөл",
        "fictitious_name": "Зохиомол нэр",
        "_color": "Өнгө"
    },
    "dataForm": {
        "resetFrom": "Шинээр бөглөх",
        "save": "Хадгалах",
        "pleaseWait": "Түр хүлээнэ үү!",
        "fillInTheNewOne": "Шинээр бөглөх",
        "close": "Хаах",
        "basicSettings": "Үндсэн тохиргоо",
        "configureTheData": "Өгөгдөл тохируулах",
        "trigger": "Триггер",
        "informationLink": "Мэдээллийн холбоос",
        "GetValuesFromTheTable": "Хүснэгтээс утга авах",
        "Geographic": "Газарзүйн",
        "AdditionalValues": "Нэмэлт утгууд",
        "selectMultipleImg": "Олон зураг сонгох эсэх",
        "TypeOfTheEditor": "Editor-н төрөл",
        "Placeholder": "Орлуулагч",
        "default_Value": "Анхдагч утга",
        "Get_value_parameter": "Параметрээс утга авах",
        "Parameter_name": "Параметрийн нэр",
        "Get_user_ID": "Хэрэглэгчийн ID авах эсэх",
        "Consolidation_formula": "Нэгтгэл томъёо",
        "Whether_to_summarize": "Нэгтгэж харуулах эсэх",
        "Choose_a_formula": "Томъёо сонгох",
        "Formula_type": "Томъёо төрөл",
        "Take_the_word_before_merger": "Нэгтгэлийн өмнө үг авах бол",
        "example": "Жишээ нь",
        "total": "нийт",
        "number": "тоо",
        "ets": "гэх мэт",
        "Symbol": "Тэмдэг",
        "get_sign_after_merger": "Нэгтгэлийн дараа тэмдэг авах бол",
        "Verification_conditions": "Шалгах нөхцөлүүд",
        "Form_of_data_verification": "Өгөгдөл шалгах хэлбэр",
        "Password_settings": "Нүүц үгийн тохиргоо",
        "Password_verification": "Нууц үг баталгаажуулах",
        "_pass": "Нууц үг",
        "Create_a_password": "Нууц үг үүсгэх",
        "Check_password_during_editing": "Засварлах үед нууц үг шалгах",
        "number_precision": "Орны нарийвчлал",
        "Whether_get_values_database": "Баазаас утга авах эсэх",
        "Choose_multiple_values": "Олон утга сонгох",
        "value": "Утга",
        "visible_word": "Харагдах үг",
        "visible_thumb": "Харагдах зураг",
        "add": "Нэмэх",
        "table": "Хүснэгт",
        "selectTable": "Хүснэгт сонгох",
        "Related_fields": "Холбогдох талбар",
        "Visible_fields": "Харагдах талбарууд",
        "Select_fields": "Талбарууд сонгох",
        "Sort_field": "Эрэмбэлэх талбар",
        "Father_column": "Эцэг багана",
        "form": "Формд байгаа",
        "this_table": "Энэ Хүснэгтийн",
        "Display_Add_Data_button": "Өгөгдөл нэмэх товч харуулах",
        "Add_data_Form": "Өгөгдөл нэмэх маягт",
        "List_of_tables": "Хүснэгтийн жагсаалт",
        "Link_terms": "Холбоосийн нөхцөл",
        "Get_customer": "Хэрэглэгчээс авах",
        "Custom_column": "Хэрэглэгчийн багана",
        "judgment_column": "Шүүлт хийх багана",
        "Call_from_server": "Серверээс дуудах",
        "data_loading_URL": "өгөгдөл дуудах URL",
        "Trigger_load_time": "Триггер дуудах хугацаа",
        "Example_data_returned_server": "Серверээс буцаах өгөдлийн жишээ",
        "Successful": "Амжилтай",
        "URL_call_information_link": "Мэдээллийн холбоос дуудах URL",
        "Value_table": "Утга авах хүснэгт",
        "Value_return_field": "Утга буцаах талбар",
        "Geographic_settings": "Газарзүйн тохиргоо",
        "attribute": "Атрибут",
        "properties": "шинж чанарууд",
        "Geometric_type": "Геометрийн төрөл",
        "point": "Цэг",
        "line": "Шугам",
        "polygon": "Олон өнцөгт",
        "length_center": "Төвийн уртраг",
        "latitude_center": "Төвийн өргөрөг",
        "Map_magnification": "Газрын зургийн томруулалт",
        "Background_map": "Суурь зураг",
        "Google_Street": "Google Гудамж",
        "Google_Space": "Google Сансрын",
        "Open_Street_Map": "Гудамжны зургийг нээх",
        "Check_overlap_area": "Талбайн давхцал шалгах",
        "Feature_Class_link": "Feature Class холбоос",
        "Search_field": "Хайлт хийх талбар",
        "Search_value_field": "Хайлтын утга авах талбар",
        "Success_message": "Амжилттай мессеж",
        "Error_message": "Алдааны мессеж",
        "Form_name": "Формын нэр",
        "Sub_name": "Дэд гарчиг",
        "Form_type": "Формын төрөл",
        "Simple_form": "Энгийн форм",
        "Step_by_step_form": "Алхамтай форм",
        "data_table": "Өгөгдлийн хүснэгт",
        "idField": "ID талбар",
        "Date_generated_automatically": "Огноо автоматаар үүсэх",
        "render_by_tab": "Хэсгийг таб болгох",
        "Label_location": "Лабелын байршил",
        "Form_width": "Формын өргөн",
        "Save_button_word": "Хадгалах товчний үг",
        "Padding_spacing": "Padding - зай авалт",
        "model": "Загвар",
        "displayName": "Харагдах нэр",
        "hide": "Нуух",
        "inactive": "Идэвхигүй",
        "translation": "Орчуулга",
        "formula": "Томъёо",
        "userInterface": "Харагдах байдал",
        "_subform": "Дэд форм",
        "_form": "Форм",
        "formula_conditions": "Томъёо, Нөхцөл",
        "field": "Талбар",
        "basic_from": "Үндсэн форм",
        "conditions": "Нөхцөл",
        "add_a_field": "Талбар нэмэх",
        "controller_namespace": "Controller namespace",
        "namespace": "Нэрийн орон зай",
        "before_insert": "Нэмэхийн өмнө",
        "after_insert": "Нэмсний дараа",
        "before_update": "Шинэчлэхийн өмнө",
        "after_update": "Шинэчлэгдсэний дараа",
        "_type": "Төрөл",
        "_top": "дээд",
        "_left": "зүүн",
        "Choose_type": "Төрөл сонгох",
        "min_height": "min-height",
        "Close_deletion_action": "Устгах үйлдэл хаах",
        "close_add_ons_action": "Нэмэх үйлдэл хаах",
        "row_numbering": "Мөрийн дугаарлалт",
        "Use_table_type": "Хүснэгтийн төрлийг хэрэглэх",
        "Table_Type_field": "Хүснэгтийн төрлийн талбар",
        "Table_Type_value": "Хүснэгтийн төрлийн утга",
        "Consolidation_forms_and_tables": "Маяг, хүснэгтийн нэгтгэл",
        "_link": "Холбоос",
        "iframe_page": "iframe хуудас",
        "no_action_sub_top": "Үйлдэлгүй дэд цэс дээр харуулах",
        "No_action": "Үйлдэлгүй",
        "_division": "Хуваалт",
        "menuType": "Цэсний төрөл",
        "connectionPath": "Холбох зам",
        "name": "Нэр",
        "target": "Даалгавар",
        "self": "өөрөө",
        "blank": "хоосон",
        "_new": "шинэ",
        "Get_name": "Нэр авах бол",
        "section_add": "Хэсэг нэмэх",
        "add_column": "Багана нэмэх",
        "_delete": "Устгах",
        "_move": "Зөөх",
        "graphicsManagement": "График удирдах",
        "viewPhotos": "Зураг харах",
        "createNumber": "Дугаар үүсгэх",
        "other": "Бусад",
        "download": "Татах",
        "view": "Харах",
        "pleaseSelectFile": "файлаа сонгоно уу",
        "longitude": "Уртраг",
        "latitude": "Өргөрөг",
        "cancel": "Болих",
        "enterCoordinatesPressEnter": "Солбицолоо оруулаад Enter дарна уу?",
        "clickHereSelectPhoto": "Энд дарж зургаа сонгоно уу!",
        "notFound": "Олдсонгүй",
        "confirmPassword": "Нууц үг баталгаажуулах",
        "currentPassword": "Одоогын нууц үг",
        "pleaseWriting": "бичнэ үү",
        "fromCityCenter": "Хотын төвөөс",
        "please_enter_value": "Утга оруулна уу",
        "formInformationSavedSuccessfully": "Формын мэдээлэл амжилттай хадгалагдлаа.",
        "please_enter_formula": "Томъёогоо оруулна уу",
        "savedSuccessfull": "Амжилттай хадгаллаа",
        "errorSaving": "Хадгалах үед алдаа гарлаа!",
        "formIformationSavedSuccessfull": "формын мэдээлэл амжилттай хадгалагдлаа.",
        "successDeleted": "Амжилттай устгалаа!",
        "selectDefaultMenu": "Анхдагч цэс сонгоно уу",
        "selectMenu": "Цэс сонгоно уу",
        "pleaseEnterPasswordYouUCurrentlyUsing": "Одоо хэрэглэж байгаа нууц үг ээ оруулна уу",
        "pleaseReEnterYourPassword": "Нууц үгээ дахин оруулна уу?",
        "passwordConfirmError": "Нууц үг баталгаажуулалт таарсангүй !!!",
        "informationIsIncomplete": "Мэдээлэл дутуу бөглөсөн байна",
        "trRMandatoryFieldsFillInformationLookFormAFillRequiredFieldsWithRedBorder": "Мэдээлэл бөглөх явцад заавал бөглөх хэсгүүд байна. Формыг хараад улаан хүрээтэй заавал бөглөгдөх хэсгүүдийг гүйцээж бөглөнө үү!",
        "successfullySaved": "Амжилттай хадгалагдлаа.",
        "pleaseDeleteSubDForm": "Дэд формыг устгах уу",
        "thereZNoRightChangeInformation": "Мэдээлэл өөрчлөх эрх байхгүй байна",
        "enterCoordinatesCorrectly": "Солбицол оо зөв оруулна уу",
        "error": "Алдаа",
        "theSiteHasNotBeenSelected": "Талбай сонгогдоогүй байна",
        "noSiteFound": "Талбай олдсонгүй",
        "dataNotFound": "Өгөгдөл сонгогдоогүй байна",
        "pleaseCompleteFirstLine": "Эхний мөрийг гүйцэд бөглөнө үү",
        "search": "Хайх",
        "values": "Утга",
        "rowAdd": "Мөр нэмэх"
    },
    "dataGrid": {
        "infoCourt": "Мэдээлэл шүүх",
        "filtering": "Шүүж харах",
        "ruSureYouDeleteInfo": "Та уг мэдээллийг устгахдаа итгэлтэй байна уу ?",
        "yes": "Тийм",
        "no": "Үгүй",
        "total": "Нийт",
        "updateDataFromExcelFile": "Excel Файлаас өгөгдөл шинэчлэх",
        "default_Value": "Анхдагч утга",
        "methodOfComparison": "Харьцуулалт хийх арга",
        "parameterComparison": "Параметрийн харьцуулалт",
        "whetherLookSidebarSearch": "Хажуу талын хайлтад харагдах эсэх",
        "dataLink": "Өгөгдлийн холбоос",
        "data_settings": "Өгөгдлийн тохиргоо",
        "basicSettings": "Үндсэн тохиргоо",
        "selectTable": "Хүснэгт сонгох",
        "table": "Хүснэгт",
        "tableList": "Хүснэгтийн жагсаалт",
        "Related_fields": "Холбогдох талбар",
        "Visible_fields": "Харагдах талбарууд",
        "Select_fields": "Талбарууд сонгох",
        "Select_field": "Талбар сонгох",
        "Sort_field": "Эрэмбэлэх талбар",
        "Father_column": "Эцэг багана",
        "Link_terms": "Холбоосийн нөхцөл",
        "inSearch": "Шүүлтэнд байгаа",
        "this_table": "Энэ Хүснэгтийн",
        "Get_customer": "Хэрэглэгчээс авах",
        "custom_column": "Хэрэглэгчийн багана",
        "judgment_column": "Шүүлт хийх багана",
        "viewList": "Жагсаалт харах",
        "image": "Зураг",
        "values": "Утга",
        "visible_word": "Харагдах үг",
        "add": "Нэмэх",
        "linkSettings": "Холбоосийн тохиргоо",
        "insertList": "Холбоос оруулах",
        "linkIcon": "Холбоос дүрс",
        "showOnlyIcon": "Зөвхөн дүрс харуулах",
        "pinColumn": "Багана хадах",
        "linkType": "Холбоосийн төрөл",
        "pinPosition": "Хадах байршил",
        "onLeft": "зүүн талд",
        "onRight": "баруун талд",
        "radioSettings": "Radio тохиргоо",
        "additionalSettings": "Нэмэлт тохиргоо",
        "comparativeValue": "Харьцуулах утга",
        "icon": "Айкон",
        "colorCode": "Өнгөний код",
        "easyEdit": "Хялбар засвар",
        "copy": "Хувилах",
        "view": "Харах",
        "columnFilterButton": "Баганын шүүлтүүр товч",
        "displayTableFrame": "Хүснэгтийн хүрээг харуулах",
        "displayMenuColumn": "Цэсийг баганад харуулах",
        "showFullText": "Текст бүрэн харуулах",
        "reboot": "Дахин ачааллах",
        "download": "Татах",
        "pleaseSelectFile": "файлаа сонгоно уу",
        "excelUpload": "Эксел файл байршуулах",
        "exportExcel": "Эксел файл экспортлох",
        "landScape": "хэвтээ",
        "portrait": "босоо",
        "paperSize": "Цаасны хэмжээ",
        "print": "Хэвлэх",
        "saveSearch": "Хайлт хадгалах",
        "pivotTool": "Пивот багаж",
        "clientRender": "Клиент рендер",
        "numbered": "Дугаарлалттай",
        "comparisonModel": "Харьцуулах модел",
        "selectSameValues": "Ижил утгуудыг сонгох",
        "multipleLinesChooseFrom": "Олон мөр зэрэг сонгох",
        "width": "өргөнтэй",
        "staticWidth": "Статик өргөн",
        "destroyedCanBeRestored": "Устсаныг сэргээж болох",
        "paging": "Хуудаслалт",
        "edit": "Засах",
        "name": "Нэр",
        "basic": "Үндсэн",
        "basicTable": "Үндсэн хүснэгт",
        "idField": "ID талбар",
        "data_table": "Өгөгдлийн хүснэгт",
        "pleaseWait": "Түр хүлээнэ үү!",
        "save": "Хадгалах",
        "appearanceName": "Харагдах нэр",
        "hide": "Нуух",
        "court": "Шүүх",
        "searchResults": "Хайлтанд илрэх",
        "translation": "Орчуулга",
        "tobePublished": "Хэвлэгдэх",
        "updateSelectedLineData": "Сонгосон мөрийн өгөдөл шинэчлэх",
        "whenEnteringDataFromExcelFile": "Эксел файлаас өгөгдөл оруулах бол",
        "filtersettings": "Шүүлтүүр тохиргоо",
        "excel": "Эксел",
        "model": "Загвар",
        "updateSelectedLineDataSettings": "Сонгосон мөрийн өгөдөл шинэчлэх тохиргоо",
        "fieldName": "Талбар нэр",
        "buttonName": "Товчлуур нэр",
        "updateAndReboot": "Шинэчилээд дахин ачаалах",
        "countingAssociatedInfo": "Холбогдох мэдээллийг тоолох",
        "relatedTable": "Холбогдох хүснэгт",
        "relatedFields": "Холбогдох талбар",
        "fatherField": "Эцэг талбар",
        "consolidationFormulas": "Нэгтгэл & Томъёо",
        "formula": "Томьёо",
        "resultsStorageArea": "Үр дүн хадгалах талбар",
        "consolidation": "Нэгтгэл",
        "consolidationType": "Нэгтгэл төрөл",
        "consolidationFormula": "Нэгтгэлийн томьёо",
        "conditionTrigger": "Нөхцөл & Триггер",
        "beforeCallingFromDatabase": "Өгөгдөл баазаас дуудахын өмнө",
        "afterCallingFromDatabase": "Өгөгдөл баазаас дуудсаны дараа",
        "beforeDeleting": "Устгахын өмнө",
        "afterDeleting": "Устгасны дараа",
        "beforePrinting": "Хэвлэхийн өмнө",
        "cacheClearTriggerLabel": "Cache цэвэрлэх холбоос",
        "spreadsheetForm": "Хүснэгтэн форм",
        "fromType": "Форм төрөл",
        "update": "Шинэчлэгдэх",
        "post": "Нийтлэх",
        "editable_UpdateLink": "Засварлах боломжтой - холбоосын шинэчлэлт",
        "fixEntireLine": "Бүтэн мөрөөр засах",
        "switchEditMode": "Засварлах горимд шилжих",
        "withOneClick": "нэг товшилтоор",
        "highlightChanges": "Өөрчлөлтийг ялгаж харуулах",
        "saveChangesBulk": "Өөрчлөлтийг бөөнөөр хадгалах",
        "gbExcelImport": "Excel import",
        "excelImportFieldName": "Excel багана нэр",
        "excelImportFormTitle": "Excel оруулах үеийн тохиргоо",
        "excelUploadSampleFile": "Жишээ файл оруулах",
        "excelUploadRowtoStart": "Excel файл уншиж эхлэх мөрийн дугаар",
        "excelUploadCustomUrl": "Excel файл хуулах үед хэрэглэгдэх custom холбоос",
        "excelImportModalTitle": "Excel файлаас өгөгдөл оруулах",
        "appearance": "Харагдах байдал",
        "dataTable": "Өгөгдлийн хүснэгт",
        "filter": "Шүүлтүүр",
        "mini": "Мини",
        "simple": "Энгийн",
        "size": "Хэмжээ",
        "controllerNameSpace": "Удирдлагын боломжит үйлдлүүд",
        "namespace": "Нэрийн орон зай",
        "beforeFetch": "Авахаас өмнө",
        "afterFetch": "Авсны дараа",
        "symbol": "Тэмдэг",
        "type": "Төрөл",
        "nickName": "Харагдах нэр",
        "filtersAndSelectedLineSettings": "Шүүлтүүр, сонгосон мөрийн тохиргоо",
        "sort": "Эрэмбэлэх",
        "column": "Багана",
        "delete": "Устгах",
        "actions": "Үйлдлүүд",
        "firstColumn": "эхний багананд",
        "buttonEdit": "Товч засвар",
        "doubleClicktoEdit": "Давхар товшилтоор засах",
        "actionsField": "Үйлдлүүд талбар",
        "performActionWithMouse": "Үйлдэл хулганаар хийх",
        "renew": "Шинэчлэх",
        "tableHeaderTemplate": "Хүснэгтийн толгойн загвар",
        "createHeaderTemplate": "Толгойн загвар үүсгэх",
        "addLine": "Мөр нэмэх",
        "addLineBelow": "Доор мөр нэмэх",
        "deleteThisLine": "Энэ мөрийг устгах уу?",
        "addColumnAfterThisColumn": "Энэ баганы дараа багана нэмэх",
        "pleaseDeleteThisCell": "Энэ нүдийг устгах уу",
        "checkModel": "Загвар шалгах",
        "height": "өндөр",
        "widthu": "өргөн",
        "row": "мөр",
        "selectPaperSize": "Цаасны хэмжээ сонгох",
        "currencySelection": "Валют сонгох",
        "tugrug": "Төгрөг",
        "dollar": "Доллар",
        "euro": "Евро",
        "yen": "Японы иен",
        "austDollar": "Австрали доллар",
        "rubli": "Рубль",
        "choosevalue": "Утга сонгох",
        "pleaseWaitForLoading": "ачаалахыг хүлээнэ үү",
        "successfullySaved": "Амжилттай хадгалагдлаа.",
        "formInformationSavedSuccessfully": "Формын мэдээлэл амжилттай хадгалагдлаа.",
        "anErrorOccurredWhileSaving": "Хадгалах үед алдаа гарлаа!",
        "successfullyDeleted": "Амжилттай устгалаа!",
        "makeExcel": "Эксэл гаргах",
        "plseEnterValue": "Утга оруулна уу",
        "updatedSuccessfully": "Амжилттай шинэчлэгдлээ",
        "infoDeleted": "Мэдээлэл устлаа",
        "tableDataHasBeenSuccessfullyEdited": "хүснэгтийн мэдээлэл амжилттай засагдлаа.",
        "formInfoSavedSuccessfully": " формын мэдээлэл амжилттай хадгалагдлаа.",
        "errorOccurredWhileUpdating": " Шинэчлэх үед алдаа гарлаа.",
        "pleaseSelectUpdateLine": " Шинэчлэх мөрөө сонгоно уу.",
        "errorOccWhileDeleting": "Устгах үед алдаа гарлаа",
        "errorMsg": "Уучлаарай алдаа гарлаа",
        "noChangesHaveBeenReported": "Өөрчлөлт орсон мэдээлэл байхгүй байна",
        "theme":"Загвар"
    },
    "dataSource": {
        "database": "Өгөгдлийн сан",
        "add": "Нэмэх",
        "view": "харах",
        "pleaseEnterSearchValue": "Хайх утгаа оруулна уу...",
        "pleaseWait": "Түр хүлээнэ үү!",
        "yes": "Тийм",
        "no": "Үгүй",
        "deleteData": "Өгөгдөлийг устгах уу?",
        "dataProcessing": "Өгөгдөл боловсруулах",
        "characteristics": "Шинж чанар",
        "basic": "Үндсэн",
        "column": "Багана",
        "name": "Нэр",
        "additional": "Нэмэлт",
        "filter": "Шүүлтүүр",
        "data": "Өгөгдөл",
        "save": "Хадгалах",
        "tableList": "Хүснэгтийн жагсаалт",
        "viewList": "View жагсаалт",
        "aggregation": "Нэгтгэх",
        "sort": "Эрэмбэлэх",
        "noSort": "Эрэмблэхгүй",
        "use": "Хэрэглэх",
        "grouping": "Бүлэглэх",
        "type": "Төрөл",
        "alias": "Зохиомол нэр",
        "select": "Сонгох",
        "bolomjitTableAndView": "Боломжит table болон view",
        "selectTable": "Хүснэгт сонгох",
        "applications": "Програмууд",
        "errorOccurredWhileSaving": "Хадгалах явцад алдаа гарлаа!"
    },
    "role": {
        "administraationRightsManagment": "ХАНДАХ ЭРХ УДИРДАХ",
        "welcome": "Тавтай морил!",
        "loggedIn": "Нэвтэрсэн хэрэглэгч",
        "personalInfo": "Хувийн мэдээлэл",
        "changePass": "Нууц үг солих",
        "superAdminManagement": "Сүпер админ удирдлага",
        "logout": "Системээс гарах",
        "pleaseWait": "Түр хүлээнэ үү!",
        "add": "Нэмэх",
        "pleaseSelectRole": "Үүрэг сонгоно уу?",
        "role": "Үүрэг",
        "additional": "Нэмэлт",
        "dataSource": "Мэдээллийн эх сурвалж",
        "userList": "Хэрэглэгчдийн жагсаалт",
        "import": "Импорт хийх",
        "register": "Бүртгэх",
        "confirm": "Баталгаажуулах",
        "save": "Хадгалах",
        "menuSelection": "Цэс сонгох",
        "possibleTableView": "Боломжиж table болон view",
        "table": "Хүснэгт",
        "name": "Нэр",
        "displayName": "Харагдах нэр",
        "note": "Тайлбар",
        "cancel": "Болих",
        "defaultMenu": "Анхдагч цэс",
        "chart": "График",
        "tableName": "Хүснэгтийн нэр",
        "table_name": "Table нэр"
    },
    "project": {
        "project": "ТӨСӨЛ",
        "settings": "Тохиргоо",
        "data_recording_environment": "ӨГӨГДӨЛ БҮРТГЭХ ОРЧИН ҮҮСГЭГЧ",
        "_form": "Маягт",
        "table": "Хүснэгт",
        "form_and_table_consolidation": "Маягт, хүснэгт нэгтгэл",
        "data_processor": "МЭДЭЭЛЭЛ БОЛОВСРУУЛАГЧ",
        "_chart": "График",
        "original_preparation": "Эх бэлтгэл",
        "analysis": "Анализ",
        "target_statement": "Зорилтод мэдэгдэл",
        "graphql_management": "Graphql удирдлага",
        "menu": "ЦЭС",
        "menu_settings": "Цэсний тохиргоо",
        "data_settings": "Өгөгдлийн тохиргоо",
        "project_key": "Төслийн түлхүүр",
        "server_languege_framework": "Сервер талын хэл болон framework",
        "create_using": "ашиглан үүсгэх",
        "download_create_file": "Файл татаж үүсгэх",
        "lambda": "Ламбда",
        "lambda_cli": "Ламбда CLI",
        "lambda_example_app": "Lambda жишээ програм",
        "l_key": "түлхүүр",
        "create": "үүсгэх",
        "lambda_settings": "Ламбда тохиргоо",
        "laravel_framework": "PHP: Ларавелийн framework",
        "go_framework": "Go: Echo framework",
        "database": "Мэдээллийн сан",
        "database_connect": "Өгөгдлийн сан холбох",
        "ready": "Бэлэн",
        "_success": "Танд амжилт хүсье",
        "type": "төрөл",
        "manage_access_rights": "Хандах эрх удирдах",
        "add": "Нэмэх",
        "menuSelection": "Цэс сонгох",
        "default_menu": "Анхдагч цэс",
        "lambda_platform": "composer create-project lambda-platform/laravel",
        "composer": "Composer",
        "_save": "Хадгалах",
        "optional": "Нэмэлт",
        "data_source": "Мэдээллийн эх сурвалж",
        "_moqup": "Мокуп",
        "user_list": "Хэрэглэгчийн жагсаалт",
        "_import": "Импорт хийх",
        "register": "Бүртгэх",
        "_confirm": "Баталгаажуулах",
        "deleteData": "Өгөгдөлийг устгах уу?",
        "form_value": "Форм (Авах утга)",
        "alertSelectColumns": "Харгалзах багнуудыг сонгоно уу",
        "errorMsg": "Уучлаарай алдаа гарлаа",
        "please_wait": "Түр хүлээнэ үү"
    },
    "puzzle": {
        "manage_access_rights": "Хандах эрх удирдах",
        "data_recording_environment": "ӨГӨГДӨЛ БҮРТГЭХ ОРЧИН ҮҮСГЭГЧ",
        "_form": "Маягт",
        "table": "Хүснэгт",
        "form_and_table_consolidation": "Маягт, хүснэгт нэгтгэл",
        "web_page": "Вэб хуудас",
        "data_processor": "МЭДЭЭЛЭЛ БОЛОВСРУУЛАГЧ",
        "data_settings": "Өгөгдлийн тохиргоо",
        "_chart": "График",
        "original_preparation": "Эх бэлтгэл",
        "_report": "Тайлан",
        "analysis": "Анализ",
        "target_statement": "Зорилтод мэдэгдэл",
        "graphql_management": "Graphql удирдлага",
        "usersAndUserGroups": "ХЭРЭГЛЭГЧ, ХАНДАХ ЭРХ",
        "users": "Хэрэглэгчид",
        "userGroupsPermission": "Хандах эрх, Зөвшөөрөл",
        "menu_settings": "Цэсний тохиргоо",
        "logOut": "Гарах",
        "cancel": "Болих",
        "please_wait": "Түр хүлээнэ үү",
        "add": "Нэмэх",
        "_save": "Хадгалах",
        "optional": "Нэмэлт",
        "duties": "Үүрэг",
        "_name": "Нэр",
        "appearance_name": "Харагдах нэр",
        "note": "Тайлбар",
        "please_select_role": "Үүрэг сонгоно уу",
        "data_source": "Мэдээллийн эх сурвалж",
        "_moqup": "Мокуп",
        "user_list": "Хэрэглэгчийн жагсаалт",
        "_import": "Импорт хийх",
        "default_menu": "Анхдагч цэс",
        "register": "Бүртгэх",
        "_confirm": "Баталгаажуулах",
        "list_grid": "Жагсаалт | Grid (шүүлтүүр)",
        "custom_column": "Хэрэглэгчийн багана",
        "judgment_column": "Шүүлт хийх багана",
        "value_column": "Утга багана",
        "delete_data": "Өгөгдөлийг устгах уу",
        "menuSelection": "Цэс сонгох",
        "not_found": "олдсонгүй",
        "meaningTake": "Авах утга",
        "filter": "Шүүлтүүр"
    },
    "notify": {
        "notice": "Мэдэгдлүүд",
        "no_notice": "Одоогоор мэдэгдэл байхгүй байна!",
        "view_all_notifications": "Бүх мэдэгдлийг харах",
        "total": "Нийт",
        "clear_notification": "Бүгдийн үзсэн болгох"
    },
    "appAdmin": {
        "manual": "Гарын авлага",
        "logOut": "Гарах",
        "cancel": "Болих",
        "add": "Нэмэх",
        "minus": "Хасах",
        "pleaseWait": "Түр хүлээнэ үү!",
        "pleaseEnterSearchValue": "Хайх утгаа оруулна уу...",
        "delete_data": "Өгөгдөлийг устгах уу?",
        "no": "Үгүй",
        "yes": "Тийм",
        "settings": "Тохиргоо",
        "menu_location": "Цэсийн байршил",
        "stepped": "Шаталсан",
        "stepped_small": "Шаталсан жижиг",
        "decomposes": "Задардаг",
        "cross": "Хөндлөн",
        "color_selection": "Өнгөний сонголт",
        "dark_mode": "Харанхуй горим",
        "bright_mode": "Гэрэлтэй горим",
        "description": "Маршрутын мэдээлэл зөв гаргахын тулд агентуудыг нэмэхдээ дээрээс нь доошоо хаанаас хаа хүртэл гэдгээ оруулна уу?",
        "data_processor": "Мэдээлэл боловсруулагч",
        "original_preparation": "Эх бэлтгэл",
        "dataProcessing": "Өгөгдөл боловсруулах",
        "graphics_generator": "График үүсгэгч",
        "point": "Цэг"
    },
    "moqup": {
        "elements": "Элемэнтүүд",
        "chart": "График",
        "save": "Хадгалах",
        "embedlink": "Embed холбоос",
        "edit": "Засах",
        "phone": "Утас",
        "tablet": "Таблет",
        "computer": "Компьютер",
        "bigComputer": "Том компьютер"
    },
    "page": {
        "pageNotFound": "Хуудас олдсонгүй."
    },
    "alertMessage": {
        "anErrorOccurredWhileSaving": "Хадгалах үед алдаа гарлаа!",
        "successfullyDeleted": "Амжилттай устгалаа!",
        "plseEnterValue": "Утга оруулна уу",
        "updatedSuccessfully": "Амжилттай шинэчлэгдлээ",
        "infoDeleted": "Мэдээлэл устлаа",
        "savedSuccessfull": "Амжилттай хадгаллаа",
        "confirm": "Баталгаажуулах",
        "errorOccurredWhileUpdating": " Шинэчлэх үед алдаа гарлаа.",
        "pleaseSelectUpdateLine": " Шинэчлэх мөрөө сонгоно уу.",
        "errorOccWhileDeleting": "Устгах үед алдаа гарлаа",
        "errorMsg": "Уучлаарай алдаа гарлаа",
        "noChangesHaveBeenReported": "Өөрчлөлт орсон мэдээлэл байхгүй байна",
        "pleaseWait": "Түр хүлээнэ үү!",
        "userDeleted": "Хэрэглэгч устгагдлаа",
        "successDeleted": "Амжилттай устгалаа!",
        "userInformationRe": "Хэрэглэгчийн мэдээлэл сэргээгдлээ",
        "errorRetriev": "Мэдээлэл сэргээхэд алдаа гарлаа!",
        "notFound": "Хайлтанд илэрц олдсонгүй!",
        "imformation_registered": "Таны мэдээлэл амжилттай бүртгэгдлээ. Түр хүлээнэ үү",
        "errorServer": "Серверт алдаа гарлаа",
        "errorSendingMail": "И-мэйл илгээх үед алдаа гарлаа",
        "please_enter_value": "Утга оруулна уу",
        "formInformationSavedSuccessfully": "Формын мэдээлэл амжилттай хадгалагдлаа.",
        "please_enter_formula": "Томъёогоо оруулна уу",
        "errorSaving": "Хадгалах үед алдаа гарлаа!",
        "formIformationSavedSuccessfull": "формын мэдээлэл амжилттай хадгалагдлаа.",
        "selectDefaultMenu": "Анхдагч цэс сонгоно уу",
        "selectMenu": "Цэс сонгоно уу",
        "form_value": "Форм (Авах утга)",
        "alertSelectColumns": "Харгалзах багнуудыг сонгоно уу",
        "please_wait": "Түр хүлээнэ үү",
        "pageNotFound": "Хуудас олдсонгүй"
    },
    "crud": {
        "registration_history": "Бүртгэлийн түүх",
        "Information_viewing_history": "Мэдээлэл үзсэн түүх",
        "_add": "Нэмэх",
        "_save": "Хадгалах",
        "re_call": "Дахин ачааллах",
        "_print": "Хэвлэх",
        "download_file": "Excel файлаар татах",
        "excelUpload": "Excel файлаас өгөгдөл оруулах"
    },
    i: {...iviewLocale.i}
}
